
// @ts-nocheck
declare var gGDPR_logoURL: string;

declare var gGDPR_privacyPolicyURL: string;

import { Emit, Component, Prop, Vue } from "vue-facing-decorator";
import SensitiveDataList from './SensitiveDataList.vue';
import ConsentItem from './ConsentItem.vue';

import { UsUt as UsUtV1 } from '@iabgpp/cmpapi'; 
import { updateCMPUtah } from './updateCMPFuncs.js'

@Component({
  components: {
    SensitiveDataList,
    ConsentItem
  },
  props: {
    cmpApi: Object,
  },  

})


export default class LayerStateUtah extends Vue {

	privacyPageURL = "";
  forcedFixedPosition = false;
  logo_URL = typeof gGDPR_logoURL  == "string" ? gGDPR_logoURL : "";

  consentToSharing = true;
  consentToTargeting = true;
  sectionName = UsUtV1.NAME
  sectionID = UsUtV1.ID
  dirty = false

	mounted(): void {
    console.log("Utah Mounted");
    this.privacyPageURL = typeof gGDPR_privacyPolicyURL  == "string" ? gGDPR_privacyPolicyURL : "";

    if ( this.cmpApi.hasSection( this.sectionName ) ) {
          this.consentToSharing = this.cmpApi.getFieldValue(this.sectionName, 'SaleOptOut' ) == 2  ? true : false;
          this.consentToTargeting = this.cmpApi.getFieldValue(this.sectionName, 'TargetedAdvertisingOptOut') == 2  ? true : false;
        }
      else  {
		updateCMPUtah( true, this.cmpApi, this.consentToSharing, this.consentToTargeting )
      }
	}

  sensitiveDataChange( consentArray: any ) {
    console.log("LayerStateUtah: sensitiveDataChange(): event=", consentArray);
    this.dirty = true;
  } 


  @Emit('changeViewEvent')
	saveSettingsClick( consentToAll : Boolean ): string {

    if ( consentToAll)  {
      this.consentToSharing = true;
      this.consentToTargeting = true;
    }

    		updateCMPUtah( consentToAll, this.cmpApi, this.consentToSharing, this.consentToTargeting )
    this.cmpApi.fireEvent( "sectionChanged", this.sectionName);
    return 'close'
	}
  
}
